
import { defineComponent, ref } from "vue";
import SimulationTemplate from "@/templates/SimulationTemplate.vue";
import BaseSimulationVariables from "@/components/BaseSimulationVariables.vue";
import CommunitySimulationVariables from "@/components/CommunitySimulationVariables.vue";
import router from '@/router';
import { IOptions } from "@/utils/types";

export default defineComponent({
  components: {
    SimulationTemplate,
    BaseSimulationVariables,
    CommunitySimulationVariables
  },
  setup() {
    const options = ref<IOptions>({
      width: 500,
      height: 500,
      amountParticles: 300,
      speed: 0.5,
      size: 4,
      i0: 3,
      infectionRadius: 10,
      infectionRate: 0.22,
      deathRate: 0.036,
      recoveryRate: 19 * 24,
      quarantine: false,
      testsPerDay: 10,
      maskInfectionRate: 0.1,
      maskParticipation: 0,
      socialDistancing: 0.8,
      socialDistancingParticipation: 0,

      communities: 4,
      border: 0.97,
      travelsPerDay: 2
    });

    return {
      options
    };
  },
});
